class Certificate {
	id = null;
	name = '';
	price = 0;
	validity = null;
	provisions = null;
	unlimited_validity = false;
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Certificate;
